import React, { useState } from 'react';
import axios from 'axios';

const PhoneInfo = (props) => {
  const [contacted, setContacted] = useState(props.contacted);
  const toggleContacted = () => {
    const action = contacted ? 'remove' : 'add';
    axios
      .get(`/${props.subDir}/shortlist.pl`, {
        params: {
          function: action,
          context: 'contacted',
          flatshare_id: props.advert.id,
          flatshare_type: props.advert.type,
          search_id: props.search.id,
          search_results: props.search.results,
          city_id: props.search.city_id,
          featured: props.advert.featured,
          format: 'json',
        },
      })
      .then((data) => {
        setContacted(!contacted);
      });
  };
  return (
    <div className="contact-phone">
      <p className="contact-phone__advert-title">{props.advert.title}</p>
      {props.advertiser.phone_number ? (
        <div>
          <a
            href={`tel:${props.advertiser.phone_number}`}
            className="button button--secondary button--large button--wide"
          >
            <div className="button__content">
              <span className="button__icon">
                <i className="far fa-phone" />
              </span>
              <span className="button__text">
                <strong>{props.advertiser.phone_number}</strong>
              </span>
            </div>
          </a>
          <div className="contact-phone__mark-as-contacted">
            <div className="form-group">
              <div className="form-group__checkbox">
                <input
                  checked={contacted}
                  onChange={toggleContacted}
                  type="checkbox"
                  name="contacted"
                  id="contacted"
                />
                <label htmlFor="contacted">
                  {props.localisations.mark_as_contacted}
                </label>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="contact-phone__no-phone">
          <div className="message-box message-box--warning">
            <span className="message-box__icon">
              <i className="far fa-exclamation-triangle"></i>
            </span>
            <p className="message-box__text">
              {props.localisations.please_email}
              <a
                href={`/${props.subDir}/${props.scriptPath}?flatshare_id=${props.advert.id}&mode=contact&submode=byemail&flatshare_type=${props.advert.type}&search_id=${props.search.id}&search_results=${props.search.results}&city_id=${props.search.city_id}&featured=${props.advert.featured}&alert_id=${props.alertId}&alert_type=${props.alertType}&upgrade_required=${props.upgradeRequired}`}
                title={props.localisations.email_advertiser}
                rel="nofollow"
              >
                <span> {props.localisations.please_message}</span>.
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneInfo;
